//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

const window = require('../../util/window');
const SphericalMercator = require('sphericalmercator');
const turfbox = require('turf-bbox');
const turfboxbbPolygon = require('turf-bbox-polygon');

function json2layer(options) {
    const data = options.data;
    const zoom = options.zoom || 9;
    const bbox = turfbox(data);
    const poly = turfboxbbPolygon(bbox);
    const canvas = window.document.createElement('canvas');
    const merc = new SphericalMercator({
        size: 256
    });
    const tilexyz = merc.xyz(bbox, zoom);
    canvas.width = (tilexyz.maxX - tilexyz.minX + 1) * 256;
    canvas.height = (tilexyz.maxY - tilexyz.minY + 1) * 256;
    const ctx = canvas.getContext('2d');
    data.features.forEach((feature)=>{
        drawPolygon(feature.geometry, ctx, merc, zoom, tilexyz);
    });
    const url = canvas.toDataURL();
    return {url:url, bbox:poly};
}
function drawPolygon(feature, ctx, merc, zoom, tilexyz) {
    const geo = feature;
    const type = geo.type;
    if (type !== 'MultiPolygon' && type !== 'Polygon') {
        throw Error('æ°æ®ä¸æ¯ä¸ä¸ªå¤è¾¹å½¢');
    }
    if (geo.coordinates.length === 0)
        return;
    let coordinates = [];
    if (type === 'Polygon') {
        coordinates = geo.coordinates[0];
    } else {
        coordinates = geo.coordinates[0][0];
    }

    ctx.beginPath();
    ctx.fillStyle = "#ffffff";
    // ctx.strokeStyle = options.lineColor
    // ctx.lineWidth = options.lineWidth
    if (!coordinates || !coordinates.length)
        return;
    for (let i = 0; i < coordinates.length; i++) {
        const lbpx = merc.px([coordinates[i][0], coordinates[i][1]], zoom); // å·¦ä¸è§
        const x = lbpx[0] - tilexyz.minX * 256,
            y = lbpx[1] - tilexyz.minY * 256;
        if (i === 0)
            ctx.moveTo(x, y);
        else
            ctx.lineTo(x, y);
    }

    ctx.fill();
}
// function Json2layer {

//     constructor(options) {
//         this._load(options);
//     }

//     _load(options) {
//         this.data = options.data;
//         this.zoom = options.zoom || 9;
//         const bbox = turfbox(this.data);
//         const poly = turfboxbbPolygon(bbox);
//         const canvas = window.document.createElement('canvas');
//         const merc = new SphericalMercator({
//             size: 256
//         });
//         const tilexyz = merc.xyz(bbox, this.zoom);
//         canvas.width = (tilexyz.maxX - tilexyz.minX + 1) * 256;
//         canvas.height = (tilexyz.maxY - tilexyz.minY + 1) * 256;
//         const ctx = canvas.getContext('2d');
//         this.data.features.forEach((feature)=>{
//             this._drawPolygon(feature.geometry, ctx, merc, this.zoom, tilexyz);
//         });
//         this.url = canvas.toDataURL();
//         this.bbox = poly;
//         return this;
//     }

//     /**
//      * ç»å¶jsonæ°æ®
//      *
//      * @param {any} Json2layer
//      *
//      * @memberOf LercSource
//      */
//     _drawPolygon(feature, ctx, merc, zoom, tilexyz) {
//         const geo = feature;
//         const type = geo.type;
//         if (type !== 'MultiPolygon' && type !== 'Polygon') {
//             throw Error('æ°æ®ä¸æ¯ä¸ä¸ªå¤è¾¹å½¢');
//         }
//         if (geo.coordinates.length === 0)
//             return;
//         let coordinates = [];
//         if (type === 'Polygon') {
//             coordinates = geo.coordinates[0];
//         } else {
//             coordinates = geo.coordinates[0][0];
//         }

//         ctx.beginPath();
//         ctx.fillStyle = "#ffffff";
//         // ctx.strokeStyle = options.lineColor
//         // ctx.lineWidth = options.lineWidth
//         if (!coordinates || !coordinates.length)
//             return;
//         for (let i = 0; i < coordinates.length; i++) {
//             const lbpx = merc.px([coordinates[i][0], coordinates[i][1]], zoom); // å·¦ä¸è§
//             const x = lbpx[0] - tilexyz.minX * 256,
//                 y = lbpx[1] - tilexyz.minY * 256;
//             if (i === 0)
//                 ctx.moveTo(x, y);
//             else
//                 ctx.lineTo(x, y);
//         }

//         ctx.fill();
//     }

// }

module.exports = json2layer;
